module.exports = __webpack_public_path__ + "static/media/background.68d45adc.png";